<template>
    <div class="AdminAddCompanyModal">
        <h1>Create new company account</h1>
        <div class="main">
            <FormInput
                v-model="email"
                label="Email Address"
                :errors="$v.email.$error ? [
                    !$v.email.required && 'Email is required',
                    !$v.email.email && 'Has to be valid email address',
                ] : null"
            />
            <FormPasswordInput
                v-model="password"
                label="Password"
                :errors="$v.password.$error ? [
                    !$v.password.required && 'Password is required',
                ] : null"
            />
            <Row>
                <Column :md="6">
                    <FormInput
                        v-model="$v.firstName.$model"
                        label="First Name"
                        :errors="$v.firstName.$error ? [
                            !$v.firstName.required && 'First name is required',
                        ] : null"
                    />
                </Column>
                <Column :md="6">
                    <FormInput
                        v-model="$v.lastName.$model"
                        label="Last Name"
                        :errors="$v.lastName.$error ? [
                            !$v.lastName.required && 'Last name is required',
                        ] : null"
                    />
                </Column>
            </Row>

            <FormInput
                v-model="$v.companyName.$model"
                lazy
                label="Company Name"
                :errors="$v.companyName.$error ? [
                    !$v.companyName.required && 'Company name is required',
                    !$v.companyName.minLength && 'Company has to be at least 3 characters long',
                ] : null"
            />
            <FormInput
                v-model="phone"
                label="Phone"
                :errors="$v.phone.$error ? [
                    !$v.phone.required && 'Phone is required',
                ] : null"
            />
        </div>

        <div class="actions">
            <Button class="link" @click="handleCancel">Cancel</Button>
            <Button class="primary" @click="handleSubmit" :disabled="submitPending">Create Company</Button>
        </div>
    </div>
</template>

<script>
import * as api from '@/api';
import { required, email, minLength } from 'vuelidate/lib/validators';

export default {
    name: 'AdminAddCompanyModal',

    data: () => ({
        email: null,
        password: null,
        companyName: null,
        firstName: null,
        lastName: null,
        phone: null,

        submitPending: false,
    }),

    validations: {
        email: { required, email },
        password: { required, minLength: minLength(6) },
        companyName: { required, minLength: minLength(3) },
        firstName: { required },
        lastName: { required },
        phone: { required },
    },

    methods: {
        async handleSubmit() {
            if (this.submitPending) return;

            this.$v.companyName.$touch();
            this.$v.firstName.$touch();
            this.$v.lastName.$touch();
            this.$v.phone.$touch();

            if (this.$v.companyName.$invalid || this.$v.firstName.$invalid || this.$v.lastName.$invalid || this.$v.phone.$invalid) {
                return;
            }

            this.submitPending = true;
            const res = await api.createOwner({
                email: this.email,
                password: this.password,
                firstName: this.firstName,
                lastName: this.lastName,
                phone: this.phone,
                company: { name: this.companyName },
            });
            this.submitPending = false;

            if (res.error) {
                return this.$awn.alert('Failed to create company account');
            }

            this.$awn.success('Company account created successfully');
            this.$emit('close');
        },

        handleCancel() {
            this.$emit('close');
        },
    },
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.AdminAddCompanyModal {
    @extend %modal;

    .actions {
        display: flex;
        justify-content: flex-end;
    }
}
</style>
